import { Typography } from "@mui/material"
import HighlightedText from "../HighlightSearch"

export default function TableCellPrinter({
    label,
    subLabel = "-",
    onlyLabel = false
}: CellPrinterProps) {
    return (
        <>
            <Typography variant='subtitle2'><HighlightedText text={`${label}`}/></Typography>
            {
                !onlyLabel &&
                <Typography color="gray" variant='caption'><HighlightedText text={`${subLabel}`}/></Typography>
            }
        </>
    )
}
interface CellPrinterProps {
    label: string,
    subLabel?: string,
    onlyLabel?: boolean
}